<template>
  <Modal
    v-if="modalVisible"
    :value="modalVisible"
    @input="modalVisible = $event"
    dataTestId="pax-claim-details-modal"
  >
    <div class="claim-details-modal">
      <div class="header">
        <Typography variant="body-2">Submission {{ claim.formSubmissionId }}</Typography>
        <Typography variant="h-2">Claim ID {{ claim.formSubmissionEntryId }}</Typography>
      </div>
      <Alert
        v-if="claim.reviewStatus !== 'Approved'"
        :message="alertMessage"
        :variant="alertVariant"
      />
      <div class="claim-details-modal-info">
        <div class="status-info">
          <ApprovedClaimDetails v-if="claim.reviewStatus === 'Approved'" :claim="claim" />
          <Typography
            variant="body-2"
            class="incentive-info"
            v-if="claim.Program && claim.Program.displayName"
          >
            Incentive: {{ claim.Program.displayName }}
          </Typography>
        </div>
        <ClaimDates :claim="claim" />
        <ClaimCustomer :claim="claim" />
        <ClaimProductInfo includeDescription :claim="claim" />
        <ClaimSubmitterDetails :claim="claim" />
      </div>
      <div class="claim-details-documents">
        <Typography variant="h-2">Documents</Typography>
        <FormFileList
          :attachmentsItem="claim.FormAttachments"
          :hasAdditionalClaimants="hasAdditionalClaimants"
        />
      </div>
    </div>
  </Modal>
</template>

<script>
import Typography from "@/components/generic/Typography.vue";
import Modal from "@/components/generic/Modal.vue";
import Alert from "@/components/generic/Alert.vue";
import ClaimDates from "./claim-info/ClaimDates.vue";
import ClaimCustomer from "./claim-info/ClaimCustomer.vue";
import ClaimProductInfo from "./claim-info/ClaimProductInfo.vue";
import ClaimSubmitterDetails from "./claim-info/ClaimSubmitterDetails.vue";
import ApprovedClaimDetails from "./claim-info/ApprovedClaimDetails.vue";
import FormFileList from "@/components/forms/FormFileList.vue";

export default {
  components: {
    Typography,
    Modal,
    Alert,
    ClaimDates,
    ClaimCustomer,
    ClaimProductInfo,
    ClaimSubmitterDetails,
    ApprovedClaimDetails,
    FormFileList,
  },
  name: "ClaimDetailsModal",
  props: {
    claim: {
      type: Object,
      required: true,
    },
    value: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    hasAdditionalClaimants() {
      const list =
        this.claim?.additionalClaimants || this.claim?.claimDependencies?.additionalClaimants || [];
      return Array.isArray(list) && list.length > 0;
    },
    modalVisible: {
      get() {
        return this.value;
      },
      set(newValue) {
        this.$emit("input", newValue);
      },
    },
    alertMessage() {
      if (this.claim.reviewStatus === "Pending") {
        return "Pending audit";
      } else {
        return `Claim denied. Audit notes: ${this.claim.reviewerComment}`;
      }
    },
    alertVariant() {
      if (this.claim.reviewStatus === "Pending") {
        return "info";
      } else {
        return "error";
      }
    },
  },
};
</script>

<style scoped>
.claim-details-modal {
  display: flex;
  flex-direction: column;
  text-align: left;
  gap: 1rem;
}
.header {
  display: flex;
  flex-direction: column;
}
.claim-details-modal-info {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}
.claim-details-documents {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}
.incentive-info {
  flex-shrink: 1;
}
.status-info {
  display: flex;
  flex-direction: row;
  gap: 1.5rem;
  align-items: center;
}
.paid-out-details {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  gap: 1.5rem;
  > :first-child {
    white-space: nowrap; /* Prevent wrapping within the first child */
  }
}
</style>
